import $ from 'jquery';


/* Offcanvas navigation
********************************************/

$('.js-offcanvas-toggle').on('click', function (e) {
	e.preventDefault();
	var $this = $(this);
	var offcanvasID = $this.attr('data-offcanvas');

	$( '.js-offcanvas-toggle' ).not('.js-offcanvas-toggle[data-offcanvas="' + offcanvasID + '"]').removeClass('is-active');
	$('.js-offcanvas-toggle[data-offcanvas="' + offcanvasID + '"]').toggleClass('is-active');
	$( '.js-offcanvas' ).not('.js-offcanvas[data-offcanvas="' + offcanvasID + '"]').delay(100).queue(function(){
		$(this).removeClass('is-active').dequeue();
	});
	$('.js-offcanvas[data-offcanvas="' + offcanvasID + '"]').toggleClass('is-active');

	if ( offcanvasID == 'navigation' ) {
		$('body').toggleClass('is-active--site-nav');
	} else {
		$('body').removeClass('is-active--site-nav');
	}
	if ( $this.hasClass( 'is-active' ) ) {
		$('body').addClass('c-body--freeze');
	} else {
		$('body').removeClass('c-body--freeze');
	}
	if ( offcanvasID == 'filters' && $('.js-offcanvas[data-offcanvas="' + offcanvasID + '"]').hasClass( 'is-active' ) ) {
		$('body').toggleClass('is-active--listing-filters');
		$('body').removeClass('c-body--freeze');
	} else {
		$('body').removeClass('is-active--listing-filters');
	}
});
// Close navigation when hit escape key
$('body').on("keydown", function (e) {
	if (e.keyCode == "27") {
		$('body').removeClass('c-body--freeze');
		$('body').removeClass('is-active--site-nav');
		$('.js-offcanvas-toggle').removeClass('is-active');
		$('.js-offcanvas').removeClass('is-active');
	}
});



/* Site search
********************************************/

$('.js-main-search-toggle').on('click', function (e) {
	e.preventDefault();
	$(this).toggleClass('is-active');

	const $mainSearch = $('.js-main-search');
	$mainSearch.toggleClass('is-active');
	setTimeout( () => {
		if ( $mainSearch.hasClass( 'is-active' ) ) {
			$mainSearch.find( '.c-form-element__field input' )[0].focus();
		}
	}, 100 );
});

$(document).on('click', function (e) {
	if (!$(e.target).closest('.js-main-search').length) {
		$('.js-main-search-toggle').removeClass('is-active');
		$('.js-main-search').removeClass('is-active');
	}
});



/* Sticky Header
********************************************/

/*if ($('.js-sticky-header').length) {
	stickybits( '.js-sticky-header', {
		useStickyClasses: true,
		//useFixed: true,
		//stickyBitStickyOffset: - pageHeaderHeight - 20,
		//customStickyChangeNumber: 10
	});
}*/
